import React from 'react';
import PropTypes from 'prop-types';
import { Stack, Box, Button } from '@stitch-fix/mode-react';
import './StickyCTA.module.scss';

const StickyCTA = ({ onClick, disabled, aboveButtonContent, children }) => {
  return (
    <Box
      variant={{ sm: 'card-2', below: true }}
      pb={{ sm: 1.25, md: 0 }}
      px={{ sm: 1.25, md: 0 }}
      styleName="sticky-cta"
      width="100%"
    >
      <Stack hAlign="stretch">
        <Box display={{ sm: 'block', md: 'none' }}>{aboveButtonContent()}</Box>
        <Button
          onClick={onClick}
          type="submit"
          name="commit"
          disabled={disabled}
          width="fill"
        >
          {children}
        </Button>
      </Stack>
    </Box>
  );
};

StickyCTA.propTypes = {
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  aboveButtonContent: PropTypes.func,
  children: PropTypes.node.isRequired,
};

StickyCTA.defaultProps = {
  onClick: () => {},
  disabled: false,
  aboveButtonContent: () => {},
};

export default StickyCTA;
